// No leading slash — the api instance prepends VITE_API_ENDPOINT (.../api/v1).
export const CATEGORIES_PATH = 'admin/categories';
